export const RequestProfileHeaderInfoItemName = {
  Building: 'building',
  Category: 'category',
  Deadline: 'deadline',
  Flat: 'flat',
  Owner: 'owner',
}

export const REQUEST_PROFILE_HEADER_INFO_ITEM_TITLE_KEYS = {
  [RequestProfileHeaderInfoItemName.Building]:
    'RequestProfile.HeaderBuildingLabelKey',
  [RequestProfileHeaderInfoItemName.Category]:
    'RequestProfile.HeaderCategoryLabelKey',
  [RequestProfileHeaderInfoItemName.Deadline]:
    'RequestProfile.HeaderDeadlineLabelKey',
  [RequestProfileHeaderInfoItemName.Flat]: 'RequestProfile.HeaderFlatLabelKey',
  [RequestProfileHeaderInfoItemName.Owner]:
    'RequestProfile.HeaderApplicantLabelKey',
}

export const REQUEST_PROFILE_HEADER_INFO_ITEM_EMPTY_TEXT_KEYS = {
  [RequestProfileHeaderInfoItemName.Building]:
    'RequestProfile.HeaderWithoutBuildingLabelKey',
  [RequestProfileHeaderInfoItemName.Category]:
    'RequestProfile.HeaderWithoutCategoryLabelKey',
  [RequestProfileHeaderInfoItemName.Deadline]:
    'RequestProfile.HeaderWithoutDeadlineLabelKey',
  [RequestProfileHeaderInfoItemName.Flat]:
    'RequestProfile.HeaderWithoutFlatLabelKey',
  [RequestProfileHeaderInfoItemName.Owner]:
    'RequestProfile.HeaderWithoutApplicantLabelKey',
}

export const REQUEST_PROFILE_HEADER_INFO_ITEM_ACTION_QA_NAMES = {
  [RequestProfileHeaderInfoItemName.Building]: {
    add: 'requestProfileHeaderBuildingAddBtn',
    edit: 'requestProfileHeaderBuildingEditBtn',
  },
  [RequestProfileHeaderInfoItemName.Category]: {
    add: 'requestProfileHeaderCategoryAddBtn',
    edit: 'requestProfileHeaderCategoryEditBtn',
  },
  [RequestProfileHeaderInfoItemName.Flat]: {
    add: 'requestProfileHeaderFlatAddBtn',
    edit: 'requestProfileHeaderFlatEditBtn',
  },
  [RequestProfileHeaderInfoItemName.Owner]: {
    add: 'requestProfileHeaderApplicantAddBtn',
    edit: 'requestProfileHeaderApplicantEditBtn',
  },
}

export const REQUEST_PROFILE_HEADER_INFO_ITEM_ADD_TOOLTIP_KEYS = {
  [RequestProfileHeaderInfoItemName.Building]:
    'RequestProfile.AddBuildingBtnTooltipKey',
  [RequestProfileHeaderInfoItemName.Category]:
    'RequestProfile.AddCategoryBtnTooltipKey',
  [RequestProfileHeaderInfoItemName.Flat]:
    'RequestProfile.AddFlatBtnTooltipKey',
  [RequestProfileHeaderInfoItemName.Owner]:
    'RequestProfile.AddApplicantBtnTooltipKey',
}
